import { InstaGridInfo } from "../WeddingInfo/WeddingInfo";

const InstaGrid: React.FC<InstaGridInfo> = ({
  profileImage,
  name,
  startDay,
  images,
}) => {
  const calculateDateDiff = (
    startDate: string
  ): { days: number; months: number; years: number } => {
    const start = new Date(startDate);
    const today = new Date();

    // 전체 일수 계산
    const timeDiff = today.getTime() - start.getTime();
    const days = Math.floor(timeDiff / (1000 * 3600 * 24));

    // 전체 년수 계산
    const years = today.getFullYear() - start.getFullYear();
    let months = today.getMonth() - start.getMonth();

    // 월 차이가 음수일 경우
    if (months < 0) {
      months += 12; // 1년을 더하고, 12개월을 더해줌
    }

    // 전체 월수를 계산
    const totalMonths = years * 12 + months;

    return {
      days,
      months: totalMonths,
      years: years,
    };
  };

  const { days, months, years } = calculateDateDiff(startDay);

  return (
    <div className="max-w-md mx-auto p-4 bg-white mt-12 font-gowun">
      {/* 프로필 & 닉네임 */}
      <div className="flex items-center mb-6 flex-row">
        <div className="w-24 h-24 rounded-full p-0.5">
          <img
            src={profileImage}
            alt="프로필 사진"
            className="w-full h-full object-cover rounded-full"
          />
        </div>
        <div className="ml-4">
          <div className="font-semibold text-xl text-left">{name}</div>
          <div className="flex mt-2 space-x-6">
            {/* 포스트, 팔로워, 팔로잉 개수 표시 */}
            <div className="text-center">
              <span className="font-semibold">{days}일</span>
              <p className="text-sm text-gray-500">Days</p>
            </div>
            <div className="text-center">
              <span className="font-semibold">{months}달</span>
              <p className="text-sm text-gray-500">Months</p>
            </div>
            <div className="text-center">
              <span className="font-semibold">{years}년</span>
              <p className="text-sm text-gray-500">Years</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-[1px]">
        {images.map((image, index) => (
          <div
            key={index}
            className={`relative ${
              index > images.length - 4 ? "col-span-1" : ""
            }`}
          >
            <img
              src={image}
              alt={`Post ${index + 1}`}
              className="aspect-[0.7]"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstaGrid;
